import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i2 from '@adeo/ngx-kozikaza-api';
import { BaseService, createSubResourceObservable, UserService, KOZIKAZA_API_OPTIONS } from '@adeo/ngx-kozikaza-api';
import { MediaService } from '@adeo/ngx-kozikaza-api/media';
import * as i1 from '@angular/common/http';

var ContestSubResource;
(function (ContestSubResource) {
    ContestSubResource.ContestJurors = 'jurors';
    ContestSubResource.Media = 'media';
})(ContestSubResource || (ContestSubResource = {}));

var ContestCompetitorSubResource;
(function (ContestCompetitorSubResource) {
    ContestCompetitorSubResource.Author = 'author';
    ContestCompetitorSubResource.Contest = 'contest';
})(ContestCompetitorSubResource || (ContestCompetitorSubResource = {}));

class ContestService extends BaseService {
    platformId;
    injector;
    static endpoint = '/contests';
    getWebServiceName() {
        return 'ContestWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    postContests(contest, options) {
        return this.post(ContestService.endpoint, contest, options);
    }
    getContests(subResources, options) {
        return this.getResources(ContestService.endpoint, subResources, options);
    }
    /*    getContestsNavigator(
            subResources?: ContestSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<Contest>> {
            return this.getContests(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getContest(contest, subResources, options) {
        return this.getResource(typeof contest === 'string' ? contest : contest['@id'], subResources, options);
    }
    putContest(contest, options) {
        return this.updateResource(typeof contest === 'string' ? contest : contest['@id'], contest, options);
    }
    deleteContest(contest, options) {
        return this.delete(typeof contest === 'string' ? contest : contest['@id'], options);
    }
    getSubResourceObservable(contest, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case ContestSubResource.ContestJurors:
                return createSubResourceObservable(this.injector.get(UserService).getJurorsByContest(typeof contest === 'string' ? contest : contest['@id'], subResourceRequest[1], options), options)
                    .pipe(map(jurors => {
                    contest.jurors = jurors && jurors['hydra:member'] ? jurors['hydra:member'] : jurors;
                    return contest;
                }));
            case ContestSubResource.Media:
                if (contest.media) {
                    return createSubResourceObservable(this.injector.get(MediaService).getMedia(contest.media, subResourceRequest[1], options), options)
                        .pipe(map(media => {
                        contest.media = media;
                        return contest;
                    }));
                }
                return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ContestService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ContestService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ContestService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

class ContestCompetitorService extends BaseService {
    platformId;
    injector;
    static endpoint = '/contest_competitors';
    getWebServiceName() {
        return 'ContestCompetitorWebService';
    }
    constructor(options, httpClient, platformId, cache, logger, injector) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
        this.injector = injector;
    }
    getContestCompetitors(subResources, options) {
        return this.getResources(ContestCompetitorService.endpoint, subResources, options);
    }
    /*    getContestCompetitorsNavigator(
            subResources?: ContestCompetitorSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<ContestCompetitor>> {
            return this.getContestCompetitors(subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                )
                ;
        }*/
    getContestCompetitor(contestCompetitor, subResources, options) {
        return this.getResource(typeof contestCompetitor === 'string' ? contestCompetitor : contestCompetitor['@id'], subResources, options);
    }
    postContestCompetitors(contestCompetitor, options) {
        return this.post(ContestCompetitorService.endpoint, contestCompetitor, options);
    }
    putContestCompetitor(contestCompetitor, options) {
        return this.updateResource(typeof contestCompetitor === 'string' ? contestCompetitor : contestCompetitor['@id'], contestCompetitor, options);
    }
    deleteContestCompetitor(contestCompetitor, options) {
        return this.delete(typeof contestCompetitor === 'string' ? contestCompetitor : contestCompetitor['@id'], options);
    }
    getContestCompetitorsByContest(contest, subResources, options) {
        if (options.query.has('contest')) {
            options.query = options.query.append('contest', typeof contest === 'string' ? contest : contest['@id']);
        }
        return this.getContestCompetitors(subResources, options);
    }
    exportContestCompetitorsByContest(options) {
        return this.getNoHydraMember(ContestCompetitorService.endpoint + '.csv', options);
    }
    /*    getContestCompetitorsByContestNavigator(
            contest: Partial<Contest> | string,
            subResources?: ContestCompetitorSubResources,
            options?: WebServiceOptions,
        ): Observable<HydraCollectionNavigator<ContestCompetitor>> {
            return this.getContestCompetitorsByContest(contest, subResources, options)
                .pipe(
                    map(collection => new HydraCollectionNavigator(this, collection, subResources, options)),
                );
        }*/
    resourceMap(resource) {
        for (const dateField of ['createdAt']) {
            resource[dateField] = resource[dateField] ? new Date(resource[dateField]) : resource[dateField];
        }
        return super.resourceMap(resource);
    }
    getSubResourceObservable(contestCompetitor, subResourceRequest, options) {
        switch (subResourceRequest[0]) {
            case ContestCompetitorSubResource.Author:
                if (contestCompetitor.author) {
                    return createSubResourceObservable(this.injector.get(UserService).getUser(contestCompetitor.author, subResourceRequest[1], options), options)
                        .pipe(map(author => {
                        contestCompetitor.author = author;
                        return contestCompetitor;
                    }));
                }
                return undefined;
            case ContestCompetitorSubResource.Contest:
                if (contestCompetitor.contest) {
                    return createSubResourceObservable(this.injector.get(ContestService).getContest(contestCompetitor.contest, subResourceRequest[1], options), options)
                        .pipe(map(contest => {
                        contestCompetitor.contest = contest;
                        return contestCompetitor;
                    }));
                }
                return undefined;
            default:
                return undefined;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ContestCompetitorService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ContestCompetitorService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ContestCompetitorService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }, { type: i0.Injector }]; } });

const WEB_SERVICES = [
    ContestService,
    ContestCompetitorService,
];
class ContestApiModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ContestApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.8", ngImport: i0, type: ContestApiModule });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ContestApiModule, providers: [
            ...WEB_SERVICES,
        ] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: ContestApiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                    // TODO : vérifier que nécessaire
                    // MediaApiModule,
                    ],
                    providers: [
                        ...WEB_SERVICES,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ContestApiModule, ContestCompetitorService, ContestCompetitorSubResource, ContestService, ContestSubResource };
